import PngObblighi from '../../icons/Obblighi.png';
import PngLimiti from '../../icons/Limiti.png';
import PngAltreInfo from '../../icons/AltreInfo.png';

export default () => {
    return (
        <div id="legend">
            <div><img src={PngLimiti} width="20"/>: Obbligo</div>
            <div><img src={PngObblighi} width="20"/>: Limite</div>
            <div><img src={PngAltreInfo} width="20"/>: Altre informazioni</div>
        </div>
    );
};


